import Button from '@mui/material/Button'
import { styled } from '@mui/material/styles'

const ButtonWithNoHoverShadow = styled(Button)`
    &:hover {
        background: none;
    }
`

export default ButtonWithNoHoverShadow
